import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import './Studio.css'

const studioData = {
  overview: {
    totalSites: 3,
    publishedSites: 2,
    totalVisitors: 12847,
    conversionRate: '3.2%'
  },
  sites: [
    { 
      id: 1, 
      name: 'Acme Corp Main Site', 
      domain: 'acmecorp.com', 
      status: 'published', 
      visitors: 8420,
      lastUpdated: '2 hours ago'
    },
    { 
      id: 2, 
      name: 'Product Launch', 
      domain: 'launch.acmecorp.com', 
      status: 'published', 
      visitors: 4427,
      lastUpdated: 'Yesterday'
    },
    { 
      id: 3, 
      name: 'Holiday Campaign', 
      domain: 'Not connected', 
      status: 'draft', 
      visitors: 0,
      lastUpdated: '3 days ago'
    }
  ],
  quickActions: [
    { label: 'Start new project', icon: 'plus' },
    { label: 'Connect domain', icon: 'globe' },
    { label: 'View analytics', icon: 'chart' },
    { label: 'Open in editor', icon: 'edit' }
  ]
}

function StudioDashboard() {
  return (
    <div className="studio-dashboard">
      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-label">Total Projects</span>
          <span className="stat-value">{studioData.overview.totalSites}</span>
          <span className="stat-sub">{studioData.overview.publishedSites} live</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Total Visitors</span>
          <span className="stat-value">{studioData.overview.totalVisitors.toLocaleString()}</span>
          <span className="stat-sub positive">+18.3% this month</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Conversion Rate</span>
          <span className="stat-value">{studioData.overview.conversionRate}</span>
          <span className="stat-sub positive">+0.4% vs last month</span>
        </div>
        <div className="stat-card highlight">
          <span className="stat-label">Revenue from Apps</span>
          <span className="stat-value">$12,480</span>
          <span className="stat-sub">Via Chekkouts integration</span>
        </div>
      </div>

      {/* Projects List */}
      <div className="sites-section">
        <div className="section-header">
          <h2 className="section-title">Your Projects</h2>
          <button className="btn btn-primary btn-sm">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            New project
          </button>
        </div>
        
        <div className="sites-grid">
          {studioData.sites.map(site => (
            <div key={site.id} className="site-card">
              <div className="site-preview">
                <div className="preview-placeholder">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <path d="M3 9h18"/>
                    <path d="M9 21V9"/>
                  </svg>
                </div>
              </div>
              <div className="site-info">
                <div className="site-header">
                  <h3 className="site-name">{site.name}</h3>
                  <span className={`site-status ${site.status}`}>{site.status}</span>
                </div>
                <div className="site-domain">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="2" y1="12" x2="22" y2="12"/>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                  </svg>
                  {site.domain}
                </div>
                <div className="site-meta">
                  <span className="site-visitors">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                    {site.visitors.toLocaleString()} visitors
                  </span>
                  <span className="site-updated">Updated {site.lastUpdated}</span>
                </div>
              </div>
              <div className="site-actions">
                <button className="btn btn-secondary btn-sm">Edit</button>
                <button className="btn btn-ghost btn-sm">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="1"/>
                    <circle cx="19" cy="12" r="1"/>
                    <circle cx="5" cy="12" r="1"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h2 className="section-title">Quick Actions</h2>
        <div className="actions-grid">
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="5" x2="12" y2="19"/>
                <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </div>
            <span className="action-label">Create new site</span>
          </button>
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
            </div>
            <span className="action-label">Connect domain</span>
          </button>
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 20V10"/>
                <path d="M12 20V4"/>
                <path d="M6 20v-6"/>
              </svg>
            </div>
            <span className="action-label">View analytics</span>
          </button>
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="1" y="4" width="22" height="16" rx="2"/>
                <line x1="1" y1="10" x2="23" y2="10"/>
              </svg>
            </div>
            <span className="action-label">Add Chekkouts</span>
          </button>
        </div>
      </div>

      {/* Integration Banner */}
      <div className="integration-banner">
        <div className="banner-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2"/>
            <line x1="1" y1="10" x2="23" y2="10"/>
          </svg>
        </div>
        <div className="banner-content">
          <h3>Chekkouts Integration Active</h3>
          <p>Your apps are connected to Chekkouts for payment processing. All transactions sync automatically.</p>
        </div>
        <Link to="/dashboard/payments" className="btn btn-secondary btn-sm">View payments</Link>
      </div>
    </div>
  )
}

function Studio() {
  const location = useLocation()
  const isOverview = location.pathname === '/dashboard/studio'

  const subRoutes = [
    { name: 'Dashboard', path: '/dashboard/studio', end: true },
    { name: 'Projects', path: '/dashboard/studio/projects' },
    { name: 'Editor', path: '/dashboard/studio/editor' },
    { name: 'Domains', path: '/dashboard/studio/domains' },
    { name: 'Analytics', path: '/dashboard/studio/analytics' }
  ]

  return (
    <div className="studio-page">
      {/* Header */}
      <div className="page-header">
        <div className="header-info">
          <div className="module-badge studio">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <path d="M3 9h18"/>
              <path d="M9 21V9"/>
            </svg>
          </div>
          <div>
            <h1 className="page-title">Studio</h1>
            <p className="page-subtitle">Build apps with AI in real-time</p>
          </div>
        </div>
        <div className="header-actions">
          <button className="btn btn-secondary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4"/>
            </svg>
            Settings
          </button>
          <button className="btn btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            New site
          </button>
        </div>
      </div>

      {/* Sub Navigation */}
      <nav className="sub-nav">
        {subRoutes.map(route => (
          <NavLink 
            key={route.path} 
            to={route.path} 
            end={route.end}
            className={({ isActive }) => `sub-nav-link ${isActive ? 'active' : ''}`}
          >
            {route.name}
          </NavLink>
        ))}
      </nav>

      {/* Content */}
      {isOverview ? <StudioDashboard /> : <Outlet />}
    </div>
  )
}

export default Studio
